import React from "react"
import { Show } from "react-admin"
import { usePermissions, useTranslate } from "ra-core"
import { RecordActionsTabs, SubTabProps } from "components/ui/layouts"
import ScheduleIcon from "@mui/icons-material/Schedule"
import Form from "./form"

function ObjectShow(props: React.PropsWithChildren): JSX.Element  {
    const translate = useTranslate()

    const subTabs: SubTabProps[] = [
        { label: translate("resources.schedules.name"), name: "schedules", resource: "objects", icon: <ScheduleIcon/> },
    ]

    return (
        <Show actions={<RecordActionsTabs subTabs={subTabs} />}>
            <Form readonly />
        </Show>
    )
}

export default ObjectShow
